import React from "react";
import "./style.css";

// images
//car
import car0 from "../../assets/images/3D/car0.webp";
import car1 from "../../assets/images/3D/car1.webp";
import car2 from "../../assets/images/3D/car2.webp";
import car3 from "../../assets/images/3D/car3.webp";
import car4 from "../../assets/images/3D/car4.webp";
import car5 from "../../assets/images/3D/car5.webp";
// img
import branding0 from "../../assets/images/3D/img0.avif";
import branding1 from "../../assets/images/3D/img1.avif";
import branding2 from "../../assets/images/3D/img2.avif";
import branding3 from "../../assets/images/3D/img3.webp";
import branding4 from "../../assets/images/3D/img4.avif";
import branding5 from "../../assets/images/3D/img5.avif";
import branding6 from "../../assets/images/3D/img6.webp";
import branding7 from "../../assets/images/3D/img7.webp";
// 3D
import img0 from "../../assets/images/3D/art0.webp";
import img1 from "../../assets/images/3D/art1.webp";
import img2 from "../../assets/images/3D/art2.webp";
import img3 from "../../assets/images/3D/art3.webp";
import img4 from "../../assets/images/3D/art4.webp";
import img5 from "../../assets/images/3D/art5.webp";
import img6 from "../../assets/images/3D/art6.webp";
import img7 from "../../assets/images/3D/art7.webp";
import img8 from "../../assets/images/3D/art8.webp";
import img9 from "../../assets/images/3D/art9.webp";
import img10 from "../../assets/images/3D/art10.webp";
import img11 from "../../assets/images/3D/art11.webp";
import img12 from "../../assets/images/3D/art12.webp";
import img13 from "../../assets/images/3D/art13.webp";

import Navigation from "../../components/Navigation";
import { Helmet } from "react-helmet-async";

const portfolioItemsBranding = [
	{
		id: 0,
		image: branding0,
		description: "",
	},
	{
		id: 1,
		image: branding1,
		description: "",
	},
	{
		id: 2,
		image: branding2,
		description: "",
	},
	{
		id: 3,
		image: branding3,
		description: "",
	},
	{
		id: 4,
		image: branding4,
		description: "",
	},
	{
		id: 5,
		image: branding5,
		description: "",
	},
	{
		id: 6,
		image: branding6,
		description: "",
	},
	{
		id: 7,
		image: branding7,
		description: "",
	}
];

const portfolioItemsCar = [
	{
		id: 0,
		image: car0,
		description: "",
	},
	// {
	// 	id: 1,
	// 	image: car1,
	// 	description: "",
	// },
	{
		id: 2,
		image: car2,
		description: "",
	},
	{
		id: 3,
		image: car3,
		description: "",
	},
	{
		id: 4,
		image: car4,
		description: "",
	},
	{
		id: 5,
		image: car5,
		description: "",
	},
];

const portfolioItemsArt = [
	{
		id: 0,
		// title: "Astronaut",
		image: img0,
		description: "",
	},
	{
		id: 1,
		image: img1,
		description: "",
	},
	{
		id: 2,
		image: img2,
		description: "",
	},
	{
		id: 3,
		image: img3,
		description: "",
	},
	{
		id: 4,
		image: img4,
		description: "",
	},
	{
		id: 5,
		image: img5,
		description: "",
	},
	{
		id: 6,
		image: img6,
		description: "",
	},
	// {
	// 	id: 7,
	// 	image: img7,
	// 	description: "",
	// },
	{
		id: 8,
		image: img8,
		description: "",
	},
	{
		id: 9,
		image: img9,
		description: "",
	},
	{
		id: 10,
		image: img10,
		description: "",
	},
	{
		id: 11,
		image: img11,
		description: "",
	},
	{
		id: 12,
		image: img12,
		description: "",
	},
	{
		id: 13,
		image: img13,
		description: "",
	},
];

const ThreeDWork = () => {
	return (
		<div className="collection-container">
			{/* <Sidebar currentPage="/collection" /> */}

			<main className="collection-main">
				<Navigation />
				<Helmet>
					<title>3D Design Portfolio | Big Cat Graphics</title>
					<meta
						name="description"
						content="A showcase of my 3D design projects, demonstrating creativity and technical skills in digital art."
					/>
				</Helmet>
				<div className="threeD-header" style={{backgroundImage: `url(${img1})`}}>
					<h1 className="threeD-title">3D Design Portfolio</h1>
					<p className="threeD-subtitle">
						A showcase of my 3D design projects, demonstrating creativity and technical skills in
						digital art.
					</p>
				</div>

				{/* Portfolio Grid Art */}
				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Branding</h1>
					<div className="threeD-grid">
						{portfolioItemsBranding.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>

				{/* Portfolio Grid Art */}
				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Cars</h1>
					<div className="threeD-grid">
						{portfolioItemsCar.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>

				{/* Portfolio Grid Art */}
				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Art</h1>
					<div className="threeD-grid">
						{portfolioItemsArt.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
			</main>
		</div>
	);
};

export default ThreeDWork;
